import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { DesignCard } from "../shared/DesignCard";
import { SectionHeader } from "../shared/SectionHeader";
import { Reveal } from "../shared/Reveal";
import { buttonClass } from "../shared/Button";
import { designs } from "../../data/designs";

// [Journey] [Lead Gen] Six genuine designs → balanced 3×2 grid. Framed for downsizers: single-level living.
export function DesignDiscovery() {
  return <section id="designs" aria-labelledby="designs-heading" className="bg-paper-deep/60 py-20 md:py-28" data-id="element-214" data-mp="1v8ltx2fwwe30">
      <div className="mx-auto max-w-site px-5 md:px-10" data-id="element-215" data-mp="1gjplv5duv12e">
        <SectionHeader id="designs-heading" title="Single-level homes for your next chapter." intro="Six single-storey designs for 10m, 12.5m and 15m lots. Stone benchtops, Westinghouse appliances and 30-course ceilings as standard, and every design can be tailored to suit you." data-id="element-216" data-mp="1gh3htfq6b3ox" />

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-217" data-mp="3p94j4q3ua1yg">
          {designs.map((design, index) => <Reveal key={design.slug} delay={index % 3 * 0.05} className="h-full" data-id="element-218" data-mp="3kat6k7m5tdcj" data-mpi={index}>
              <DesignCard design={design} data-id="element-219" data-mp="1vsftege4ncl" />
            </Reveal>)}
        </div>

        <div className="mt-12 flex flex-col items-center gap-4 text-center" data-id="element-220" data-mp="3tapxygzxoqba">
          <Link to="/home-designs" className={buttonClass("primary")} data-id="element-221" data-mp="3t8lo7ifcsx33">
            Compare all designs <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-222" data-mp="bwb5ipumyy2f" />
          </Link>
          <p className="text-[16px] text-slate" data-id="element-223" data-mp="6ulpswwgxw80">
            Not sure a design suits your block?{" "}
            <Link to="/contact?project=unsure" className="font-medium text-charcoal underline underline-offset-4" data-id="element-224" data-mp="ku3lzxc3gbre">Talk to us about it.</Link>
          </p>
        </div>
      </div>
    </section>;
}